import { gql } from '@apollo/client';
import { CITY_PMC_FIELDS } from 'graphql/fields/cityPmcFields';

export const READ_CITY_PMCS_BY_ADDRESS = gql`
  ${CITY_PMC_FIELDS}
  query ReadCityPmcsByAddress($input: CityPmcsInput!) {
    readCityPmcsByAddress(input: $input) {
      ...CityPmcFields
    }
  }
`;
